import React from "react";

function Logo(props) {
    return (
        <img src={props.Url} alt={props.Label} className="logo" />
    );
}

function Page(props) {
    return (
        <div style={{ display: "flex" }}>
            <div className="left-panel">
                <div className="eone-login-hero-brand">
                    <Logo
                        Url={props.LogoUrl}
                        Label={props.LogoText ? "" : props.LogoLabel} />
                    {props.LogoText && <span>{props.LogoText}</span>}
                </div>
            </div>
            <div className="right-panel">
                <div className="eone-login-page">
                    <div className="eone-login-product-brand">
                        <img
                            src={props.ProductLogoUrl}
                            alt={props.ProductLogoText ? "" : props.ProductLogoLabel}
                            className="eone-login-product-logo" />
                        {props.ProductLogoText && <span>{props.ProductLogoText}</span>}
                    </div>
                    {props.children}
                </div>
            </div>
        </div>
    );
}

export { Page };
